<template>
  <div>
    <h1 class="user-policy-header text-secondary">{{ $t('common.paidVersionUserPolicy') }}</h1>
    <p class="mb-5">{{ $t('paidVersionUserPolicy.heading') }}</p>
    <div v-for="clause in $t('paidVersionUserPolicy.clauses')" :key="clause.title">
      <h5 class="clause-title mb-4">{{ clause.title }}</h5>
      <div v-for="subClause in clause.subClauses" :key="subClause.title" class="m-2">
        <p class="font-weight-bold mb-1">{{ subClause.title }}</p>
        <p v-if="subClause.body" class="clause-body">{{ subClause.body }}</p>
        <ul v-if="subClause.items" :class="['sub-clause', subClause.type === 0 ? 'sub-clause-decimal' : 'sub-clause-parentheses']">
          <li v-for="(item, i) in subClause.items" :key="item" class="text-pre-wrap">
            {{ item }}
            <ul
              v-if="subClause.subItems && subClause.subItems[i]"
              :class="['sub-clause', subClause.subItems[i].type === 0 ? 'sub-clause-decimal' : 'sub-clause-parentheses']">
              <li v-for="(subItem, subI) in subClause.subItems[i].items" :key="subItem" class="text-pre-wrap">
                {{ subItem }}
                <ul
                  v-if="subClause.subItems[i].thirdItems && subClause.subItems[i].thirdItems[subI]"
                  :class="[
                    'sub-clause',
                    { 'sub-clause-decimal': subClause.subItems[i].thirdItems[subI].type === 0 },
                    { 'sub-clause-parentheses': subClause.subItems[i].thirdItems[subI].type === 1 }
                  ]"
                >
                  <li v-for="thirdItem in subClause.subItems[i].thirdItems[subI].items" :key="thirdItem" class="text-pre-wrap">
                    {{ thirdItem }}
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="user-policy-footer text-secondary">
      <p>{{ $t('paidVersionUserPolicy.footer.body') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaidVersionUserPolicyContent'
}
</script>

<style scoped lang="scss">
.clause-title {
  font-size: 1.25em;
  font-weight: bold;
}
.sub-clause {
  list-style: none;
  padding-left: 0;
  display: table;
  counter-reset: table-ul;

  li {
    display: table-row;
    counter-increment: table-ul;

    &:after {
      content: "";
      display: block;
    }

    &:before {
      display: table-cell;
      padding-right: 0.4em;
    }
  }
}
.sub-clause-decimal > li:before {
  content: counter(table-ul) ".";
}
.sub-clause-parentheses > li:before {
  content: "(" counter(table-ul) ") ";
}
.user-policy-header {
  font-size: 2.5em;
  text-align: center;
  font-weight: bold;
  padding-bottom: 2rem;
}
.user-policy-footer {
  white-space: pre-wrap;
  font-weight: bold;
  padding-top: 2rem;
}
</style>
